import { Blank } from "@evergis/ui";
import styled, { css } from "styled-components";
import { FilterContainerProps, FilterScreenBreakpoint } from "./types";

export const FiltersCollapsedContainer = styled.div<FilterContainerProps>`
  margin-left: auto;

  ${({ alwaysShow = false, breakpoint = FilterScreenBreakpoint.All }) =>
    !alwaysShow &&
    css`
      @media screen and (min-width: ${breakpoint}rem) {
        display: none;
      }
    `}
`;

export const FiltersCollapsedContentContainer = styled(Blank)`
  padding: 0.75rem 1rem 0.75rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
